var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemDashDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 3a1 1 0 0 0 0 2h15.111c.498 0 .889.399.889.875v12.25a.88.88 0 0 1-.889.875H6.778a.88.88 0 0 1-.89-.875V14.64a1 1 0 1 0-2 0v3.485C3.889 19.72 5.19 21 6.779 21H18.11A2.88 2.88 0 0 0 21 18.125V5.875C21 4.28 19.7 3 18.111 3zm1 3.5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2zM2 11a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1m8 1a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2z",
  clipRule: "evenodd"
})));
export default SvgGemDashDelivery;